export default Object.freeze({
  COMPLETE_ORDER: {
    STATUS: {
      LOADING: "loading",
      SUCCESS: "success",
      ERROR: "error",
    },
  },
});
